import { render, staticRenderFns } from "./PriceTable.vue?vue&type=template&id=72dc984f&scoped=true&lang=pug&"
import script from "./PriceTable.vue?vue&type=script&lang=ts&"
export * from "./PriceTable.vue?vue&type=script&lang=ts&"
import style0 from "./PriceTable.vue?vue&type=style&index=0&id=72dc984f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc984f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VForm,VLayout,VRadio,VRadioGroup,VSpacer})
